import script from "./CompanyProfileViewerModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./CompanyProfileViewerModal.vue?vue&type=script&setup=true&lang=ts"

import "./CompanyProfileViewerModal.vue?vue&type=style&index=0&id=c943f134&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c943f134"]])

export default __exports__